<template>
    <div v-if="res != null && res != undefined">
        <el-result icon="success" title="提交成功" v-if="res.code == 1">
        </el-result>
        <el-result
            icon="error"
            title="提交失败"
            subTitle="res.data"
            v-if="res.code == 0"
        >
        </el-result>
        {{ res.data }}
    </div>
</template>

<script>
export default {
    name: "result",
    data() {
        return { res: {} };
    },
    mounted() {
        let res = this.$route.query.res;
        console.log("Result: " + res);
        this.res = res;
    },
};
</script>

<style>
</style>